import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "../data/site";
import { scrollToSection } from "../lib/lenis";

export const Services = () => (
  <section id="services" data-testid="services-section" className="bg-black px-4 md:px-10 py-20 md:py-28 border-t border-[#222]">
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
      className="mb-10 md:mb-14"
    >
      <p className="font-jetmono text-[10px] tracking-[0.35em] uppercase text-[#808080] mb-4">02 / CAPABILITIES</p>
      <h2 className="font-syncopate font-bold uppercase leading-none tracking-tight text-4xl sm:text-6xl lg:text-7xl">
        SERVICES<span className="text-outline-dim">.</span>
      </h2>
    </motion.div>

    <div className="border-t border-[#333]">
      {SERVICES.map((s, i) => (
        <motion.button
          key={s.id}
          data-testid={`service-row-${s.id}`}
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.7, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] }}
          onClick={() => scrollToSection("contact")}
          className="group w-full text-left grid grid-cols-1 lg:grid-cols-12 gap-4 lg:gap-8 items-center py-8 md:py-12 border-b border-[#333] px-2 md:px-4 hover:bg-white transition-colors duration-500"
        >
          <span className="lg:col-span-1 font-jetmono text-xs tracking-[0.2em] text-[#808080] group-hover:text-black transition-colors duration-500">
            {s.index}
          </span>
          <span className="lg:col-span-5 min-w-0 font-syncopate font-bold uppercase tracking-tight text-2xl sm:text-3xl lg:text-3xl xl:text-4xl text-white group-hover:text-black group-hover:translate-x-3 transition-[transform,color] duration-500">
            {s.title}
          </span>
          <span className="lg:col-span-4 min-w-0 font-plex font-light text-sm md:text-base text-[#A0A0A0] group-hover:text-[#222] transition-colors duration-500 max-w-xl">
            {s.description}
          </span>
          <span className="lg:col-span-2 flex lg:justify-end items-center gap-4">
            <span className="flex flex-wrap lg:justify-end gap-2">
              {s.tags.map((t) => (
                <span key={t} className="font-jetmono text-[9px] tracking-[0.15em] uppercase border border-[#333] group-hover:border-black px-2 py-1 text-[#808080] group-hover:text-black transition-colors duration-500">
                  {t}
                </span>
              ))}
            </span>
            <ArrowUpRight size={20} className="shrink-0 text-[#808080] group-hover:text-black group-hover:rotate-45 transition-[transform,color] duration-500" />
          </span>
        </motion.button>
      ))}
    </div>
  </section>
);
